
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'generalInfo': 'Opće',
	'widgetId': 'ID grafičkog elementa',
	'widgetType': 'Tip grafičkog elementa',
	'serviceability': 'Upotrebljivost',
	'copyButton': 'Kopiraj',
	'closeButton': 'Zatvori',
	'specification': 'Specifikacija',
	'viewSpecification': 'Pregled specifikacije'
});
